import { EventImgContent } from 'features/EventImgContent';

const EditImgContent = (): JSX.Element => {
	return <EventImgContent />;
};
export default EditImgContent;
